<div class="button-wrapper">
  <button class="left1" mat-raised-button (click)="btnClick()">
    <span class="style">Create User</span>
  </button>

  <button class="left1" mat-raised-button (click)="navigateToCreateTempUser()">
    <span class="style">Create Temporary User</span>
  </button>
</div>
<!---------------------------------new ui---------------------------------------------------->

<section class="content-header">
  <div class="row mb-2">
    <div class="col-sm-6">
      <h1>Users</h1>
    </div>
    <div  class="col-sm-6">
      <h2>User Type</h2>
    </div>
  </div>

  <div class="d-flex" style="position: relative;">
    <div class="input-group" style="width: 40%">
      <input
        type="search"
        class="form-control form-control-lg"
        placeholder="Search Employee"
        id="search"
        name="search"
        [(ngModel)]="search"
        (ngModelChange)="Search()"
      />
      <div class="input-group-append">
        <button type="submit" class="btn btn-lg btn-default" (click)="Search()">
          <i class="fa fa-search"></i>
        </button>
      </div>
    </div>

    <div
      class="input-group col-md-4 offset-md-2 order-md-2"
      style="margin-right: 200px"
    >
      <select
        class="form-select select2 select2-hidden-accessible"
        data-select2-id="1"
        tabindex="-1"
        aria-hidden="true"
        id="drop"
        name="drop"
        [(ngModel)]="drop"
        (ngModelChange)="Search()"
      >
        <option value="">ALL</option>
        <option
          [selected]="item.name == drop"
          *ngFor="let item of userTypedropdown"
        >
          {{ item.name }}
        </option>
      </select>
      <button
        class="btn btn-primary btn-sm ms-2"
        (click)="toggleTempFilter()"
        style="white-space: nowrap; background-color: #007bff; border-color: #007bff;">
        <i class="fas fa-filter me-1"></i>
        {{ isTemp ? 'All Employees' : 'Temp Employee' }}
      </button>
      <!-- <select class="form-select select2 select2-hidden-accessible" data-select2-id="1" tabindex="-1" aria-hidden="true"
    id="drop" name="drop" [(ngModel)]="drop" (click)="Search();">

       <option value="">ALL</option>
        <option>Admin</option>
        <option>Employee</option>
        <option>Factory_Manager</option>
        <option>Delivery_Man</option>
        <option>Manager</option>
        <option>Salesman</option>
        <option>Marketing</option>
        <option>Sales_Promoter</option>
        <option>Manager_Pro</option>
        <option>Department_Foreman</option>
        <option>Technician</option>
        <option>Helper</option>
        <option>Mixer</option>
        <option>BDM</option>
        <option>Sales_Executive</option>
        <option>Driver</option>
        <option>UAE_Wholesale_Salesman</option>
        <option>Qc_Chemist</option>

        <option>Admin_Operations</option>
        <option>Operations_Manager</option>
        <option>Hr_Manager</option>
        <option>Credit_Manager</option>
        <option>Finance_Manager</option>
        <option>Crm_Admin</option>
        <option>KSA_Salesman</option>
        <option>KSA_Foreman</option>
        <option>KSA_Helper</option>
        <option>KSA_wholesale_salesman</option>
        <option>Oman_wholesale_salesman</option>
        <option>Oman_salesman</option>
        <option>FG_dispatch</option>
        <option>factory_data_entry</option>


    </select> -->
    </div>
  </div>
</section>
<!--------------loader-------------------------->
<div *ngIf="loaderShown" class="loader"></div>
<!----------------------------------------------->

<section class="content">
  <div class="card" *ngIf="cardShown">
    <div class="card-header">
      <div class="card-tools">
        <button
          type="button"
          class="btn btn-tool"
          data-card-widget="collapse"
          title="Collapse"
        >
          <i class="fas fa-minus"></i>
        </button>
        <button
          type="button"
          class="btn btn-tool"
          data-card-widget="remove"
          title="Remove"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <table class="table table-striped projects">
        <thead>
          <tr>
            <th style="width: 20%">User Name</th>

            <th style="width: 30%">Employee Name</th>

            <th style="width: 15%">User Type</th>

            <th style="width: 10%">App version</th>

            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of output">
            <td *ngIf="c.username != 'admin'" >
              <a>
                {{ c.username }}
              </a>
            </td>

            <td *ngIf="c.username != 'admin'">
              {{ c.user_fullname }}
            </td>

            <td *ngIf="c.username != 'admin'">
              {{ c.user_type }}
            </td>

            <td *ngIf="c.username != 'admin'">
              {{ c.app_version }}
            </td>

            <td class="project-actions text-right" *ngIf="c.username != 'admin'">
              <a
                class="btn btn-primary btn-sm"
  routerLink="/admin/single-user-detail"
  [queryParams]="{ id: c.user_id }"
>
  <i class="fas fa-folder"> </i>
  View
</a>
              <a
                class="btn btn-info btn-sm left" routerLink="/admin/edit-user" [queryParams]="{ id : c.user_id}"
                
              >
                <i class="fas fa-pencil-alt"> </i>
                Edit
              </a>

              <a
                class="btn btn-danger btn-sm left"
                data-toggle="modal"
                data-target="#modal-sm"
                (click)="SetUser(c.user_id, c.username)"
              >
                <i class="fas fa-trash"> </i>
                Delete
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
<!------------------------------------------------------------>
<div class="modal fade" id="modal-sm" style="display: none" aria-hidden="true">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="modal-body">
        <p>Are you sure to delete "{{ UserName }}"?</p>
      </div>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default" data-dismiss="modal">
          No
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="DeleteUser()"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>
<!---------------------paging------------------------------------->
<ul class="pagination" *ngIf="cardShown">
  <li class="paginate_button page-item previous" id="example2_previous">
    <a
      (click)="clicks_previous()"
      aria-controls="example2"
      data-dt-idx="0"
      tabindex="0"
      class="page-link count"
      >Previous</a
    >
  </li>

  <li class="paginate_button page-item">
    <a
      aria-controls="example2"
      data-dt-idx="1"
      tabindex="0"
      class="page-link count"
      >{{ New_count + 1 }}</a
    >
  </li>

  <li class="paginate_button page-item next" id="example2_next">
    <a
      (click)="clicks_next()"
      aria-controls="example2"
      data-dt-idx="7"
      tabindex="0"
      class="page-link"
      >Next</a
    >
  </li>
</ul>

<!----------------------------------------
<div class="card">
<div class="card-header">
    <h3 class="card-title">Users Listing</h3>
 </div>
 <div class="card-body">
    <div id="example2_wrapper" class="dataTables_wrapper dt-bootstrap4">
        <div class="row"><div class="col-sm-12 col-md-6"></div>
        <div class="col-sm-12 col-md-6"></div></div><div class="row">
        <div class="col-sm-12"><table id="example2" class="table table-bordered table-hover dataTable dtr-inline collapsed" role="grid" aria-describedby="example2_info">
    <thead>
    <tr role="row">
        <th class="sorting sorting_desc" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Rendering engine: activate to sort column ascending" aria-sort="descending">User Name</th>
        <th class="sorting" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Employee Name</th>
        <th class="sorting" tabindex="0" aria-controls="example2" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">User Type</th>
    </thead>
    <tbody  *ngFor="let c of output">
    <tr class="odd" (click)='UserDetails();getValue(c.user_id)'>
    <td class="dtr-control sorting_1" tabindex="0">{{c.username}}</td>
    <td>{{c.user_fullname}}</td>
    <td>{{c.user_type}}</td>
    
    </tr>
   </tbody>
    
    </table>
</div>  
    </div>
    </div>
----------------------card ending---------->
